import React, { useState } from 'react';

import arrowButton from '../../assets/icons/collapse-arrow.svg';

import './Collapse.scss';

interface ICollapseProps {
  title: string;
  className?: string;
  children: JSX.Element;
}

const Collapse = ({ title, className, children }: ICollapseProps) => {
  const [expanded, setExpanded] = useState(true);

  const toggleExpandedState = (event: React.MouseEvent) => {
    event.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <div className={`collapse ${expanded ? 'collapse--expanded' : ''} ${className}`}>
      <button
        type="button"
        className="collapse__caption"
        aria-expanded={expanded}
        key={title}
        onClick={(event) => {
          event.stopPropagation();
          event.nativeEvent.stopImmediatePropagation();
          toggleExpandedState(event);
        }}
      >
        <span className="collapse__caption-title">{title}</span>
        <img className="collapse__caption-arrow" src={arrowButton} alt="" />
      </button>
      <div className="collapse__content">{children}</div>
    </div>
  );
};

export default Collapse;
